import * as React from "react"
import { cva } from "class-variance-authority"

import { cn } from "@/lib/utils"

const bubbleVariants = cva(
  "relative min-w-0 w-fit max-w-full overflow-visible shadow-sm",
  {
    variants: {
      variant: {
        default: "chat-bubble-default",
        muted: "chat-bubble-muted",
        subtle: "chat-bubble-subtle",
        image: "chat-bubble-image",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

const Bubble = React.forwardRef(({ className, variant, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(bubbleVariants({ variant }), className)}
    {...props}
  />
))
Bubble.displayName = "Bubble"

const BubbleContent = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("min-w-0 max-w-full px-3.5 py-2", className)}
    {...props}
  />
))
BubbleContent.displayName = "BubbleContent"

const BubbleGroup = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("flex w-full min-w-0 max-w-full flex-col gap-1", className)}
    {...props}
  />
))
BubbleGroup.displayName = "BubbleGroup"

const BubbleReactions = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("absolute -bottom-2 -right-2 z-10 flex flex-wrap gap-1", className)}
    {...props}
  />
))
BubbleReactions.displayName = "BubbleReactions"

export { Bubble, BubbleContent, BubbleGroup, BubbleReactions }
